var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnfasser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Anfasser__Icn/40px/Anfasser",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Anfasser__Group-Copy",
    transform: "translate(1 1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Icn_40px_Anfasser__Line-2",
    d: "M41 1.58578644 42.4142136 3 3 42.4142136 1.58578644 41z"
  }), /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Icn_40px_Anfasser__Line-2-Copy",
    d: "M45 5.58578644 46.4142136 7 7 46.4142136 5.58578644 45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Icn_40px_Anfasser__Line-2-Copy-2",
    d: "M49 9.58578644 50.4142136 11 11 50.4142136 9.58578644 49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Icn_40px_Anfasser__Line-2-Copy-3",
    d: "M53 13.5857864 54.4142136 15 15 54.4142136 13.5857864 53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Icn_40px_Anfasser__Line-2-Copy-4",
    d: "M57 17.5857864 58.4142136 19 19 58.4142136 17.5857864 57z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnfasser);
export default __webpack_public_path__ + "static/media/Anfasser.7d25088f6d2f44aa457678c0bdbd03f2.svg";
export { ForwardRef as ReactComponent };